module.exports = __webpack_public_path__ + "img/shireo-login.aa89d561.jpg";